import hasDiagramError from "./hasDiagramError";

function checkDiagramError(file) {
    const hasError = hasDiagramError(file?.diagram?.nodes);
    const cleanSubjectSchemaError = file?.validation.filter(v => v.code !== 'SUBJECT_SCHEMA_FETCH_FAILED');
    if (hasError) {
        const findValidationErrors = cleanSubjectSchemaError.find(v => v.code === 'DIAGRAM_ERROR');
        if (findValidationErrors) {
            return {
                ...file,
                validation: [...cleanSubjectSchemaError]
            }
        } else {
            return {
                ...file,
                validation: [...cleanSubjectSchemaError, {
                    code: 'DIAGRAM_ERROR',
                    summary: 'Errors in diagram. Please review and fix them.',
                    detail: [],
                    isNewIssue: true
                }]
            }
        }
    } else {
        const newValidation = cleanSubjectSchemaError.filter(v => v.code !== 'DIAGRAM_ERROR');
        return {
            ...file,
            validation: newValidation
        }
    }
}

export default checkDiagramError